import * as React from 'react'

const RatingIcon = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.333008" width="32" height="32" rx="16" fill="#FEF0C7" />
      <path
        d="M11.3327 22.6666V19.3333M11.3327 12.6666V9.33331M9.66602 11H12.9993M9.66602 21H12.9993M16.9993 9.99998L15.8432 13.0059C15.6552 13.4947 15.5612 13.7391 15.415 13.9447C15.2855 14.1269 15.1263 14.2861 14.9441 14.4157C14.7385 14.5618 14.4941 14.6559 14.0053 14.8439L10.9993 16L14.0053 17.1561C14.4941 17.3441 14.7385 17.4381 14.9441 17.5843C15.1263 17.7139 15.2855 17.873 15.415 18.0553C15.5612 18.2608 15.6552 18.5053 15.8432 18.9941L16.9994 22L18.1555 18.9941C18.3435 18.5053 18.4375 18.2608 18.5837 18.0553C18.7132 17.873 18.8724 17.7139 19.0546 17.5843C19.2602 17.4381 19.5046 17.3441 19.9934 17.1561L22.9993 16L19.9934 14.8439C19.5046 14.6559 19.2602 14.5618 19.0546 14.4157C18.8724 14.2861 18.7132 14.1269 18.5837 13.9447C18.4375 13.7391 18.3435 13.4947 18.1555 13.0059L16.9993 9.99998Z"
        stroke="#F79009"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RatingIcon
